import { Component, inject } from "@angular/core";

import { MAT_DIALOG_DATA } from "@angular/material/dialog";

import { AccountViewModel } from "@tylertech/tyler-api-types";

export interface AccountBudgetRecapDialogData
{
    readonly accounts: Array<AccountViewModel>;
    readonly summaryDate: Date | string;
}

@Component({
    selector: "gl-account-budget-recap-dialog",
    templateUrl: "./accountBudgetRecapDialog.tmpl.html",
    standalone: false
})
export class AccountBudgetRecapDialogComponent
{
    private readonly data = inject<AccountBudgetRecapDialogData>(MAT_DIALOG_DATA);


    get accounts(): Array<AccountViewModel> { return this.data.accounts; }
    get summaryDate(): Date | string { return this.data.summaryDate; }
}
